import { FilterViewSchema } from '@/types/schema';
import { useMeasureAndTruncate } from '@/utils/useMeasureAndTruncate';

const CHARACTER_WIDTH = 7;
const X_PADDING = 16;
const RESERVED_WIDTH = 3 * 80 + 30 + 30 + 30; // Approximate width for 3 preset buttons and the ... and + buttons

export function useVisibleFilters(
  filterViews: FilterViewSchema[],
  containerRef: React.RefObject<HTMLDivElement>,
  activeId?: string
) {
  const { visible, overflow } = useMeasureAndTruncate(
    filterViews,
    containerRef,
    {
      getCharacterCount: (filter) => filter.display_name.length,
      characterWidth: CHARACTER_WIDTH,
      additionalPadding: X_PADDING,
      reservedWidth: RESERVED_WIDTH,
      enforceReservedWidth: true,
      elementGap: 0,
      activeElementId: activeId,
      getElementId: (filter) => filter.id,
    }
  );

  return { visibleFilters: visible, overflowFilters: overflow };
}
